module.exports = __webpack_public_path__ + "media/Audio19_b.e286564d.wav";